import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/src/layouts/login.vue").then(m => m.default || m))
}